import MessageCenter from 'components/global-nav/components/MessageCenter'
import { useCallback, useState } from 'react'
import { Badge } from 'react-bootstrap'
import { Inbox } from 'components/global-nav/components/MessageCenter/types'
import { MessageCenterContext } from 'components/global-nav/components/MessageCenter/contexts'
import MessageCenterDropdownButton from 'components/global-nav/components/MessageCenterDropDownButton/MessageCenterDropdownButton'
import css from './MessageCenterMenu.scss'
import {
  lockBodyScroll,
  unlockBodyScroll,
} from 'shared/utils/lockBodyScroll/lockBodyScroll'

const parseDate = (val: Date | string | null | undefined) => {
  if (!val) return null
  if (val instanceof Date) return val.getTime()
  return Date.parse(val)
}

const MessageCenterMenu = () => {
  const [hasUnseenMessages, setHasUnseenMessages] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const handleInboxChanged = useCallback(
    (inbox: Inbox) => {
      const { lastViewedAt, messages } = inbox
      setHasUnseenMessages(
        !!messages?.some((message) => {
          if (!lastViewedAt) return true
          const lastViewed = parseDate(lastViewedAt)
          const createdAt = parseDate(message.createdAt)
          return lastViewed && createdAt && lastViewed < createdAt
        })
      )
    },
    [setHasUnseenMessages]
  )

  const handleInboxOpened = () => {
    lockBodyScroll('message-center')
    setMenuOpen(true)
  }

  const handleInboxClosed = () => {
    unlockBodyScroll('message-center')
    setMenuOpen(false)
  }

  const handleVisibilityToggled = () => {
    const isOpen = !menuOpen
    if (isOpen) {
      handleInboxOpened()
    } else {
      handleInboxClosed()
    }
  }

  const title = (
    <div className="flex-row pull-left">
      <span className={css.bellIcon}>
        {hasUnseenMessages && (
          <span
            className={css.UnreadMessagesBadge__Container}
            data-testid="unseen-messages-badge"
          >
            <Badge bsClass={css.UnreadMessagesBadge}>&nbsp;</Badge>
          </span>
        )}
      </span>
    </div>
  )

  return (
    <MessageCenterContext.Provider value={{ isOpen: menuOpen }}>
      <MessageCenterDropdownButton
        pullRight
        aria-label="message center"
        bsStyle="nav-link"
        data-testid="message-center"
        id="message-center"
        title={title}
        onClick={handleVisibilityToggled}
        onClickAway={handleInboxClosed}
        onSelect={handleInboxClosed}
      >
        <MessageCenter onInboxChanged={handleInboxChanged} />
      </MessageCenterDropdownButton>
    </MessageCenterContext.Provider>
  )
}

export default MessageCenterMenu
